"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const styles = (0, _makeStyles.default)(() => ({
  userIcon: {
    alignItems: "center",
    display: "flex",
    height: 32,
    justifyContent: "center",
    width: 32
  }
}));
var _default = exports.default = styles;